export default __webpack_public_path__ + "static/media/slider-service3.8c494bed.png";